import SubscriptionItem from 'components/RichProfile/MyAccount/AutoReplenishment/SubscriptionItem/SubscriptionItem';

export default SubscriptionItem;
